export default __webpack_public_path__ + "static/media/indicator.32cd4340.svg";